import styled from 'styled-components';

export const Wrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 24px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green6};
    background: ${({ theme }) => theme.colors.green1};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
`;

export const DescriptionWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: ${({ theme }) => theme.colors.black7};
`;

export const TimerWrapper = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black7};
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
`;

export const ExtraWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const NumberWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const PercentageWrapper = styled.div`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
`;
